<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header" style="paddingRight: 0;padding-bottom: 0">
      <el-form :model="form" class="com-search-box" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="图书名称 :" prop="name">
              <el-input v-model="form.name" placeholder="请输入图书名称"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="图书编号 :" prop="bookNo">
              <el-input v-model="form.bookNo" placeholder="请输入图书编号"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item  class="el-form-state1"  label="领取人 :" prop="useName">
              <el-select v-model="form.useName" filterable remote reserve-keyword placeholder="请选择领取人" :remote-method="remoteMethod" :loading="loading">
                <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList('form')">重置</el-button>
      </div>

    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row type="flex">
          <el-button @click="addBorrow" class="el-primary-border">
            <svg-icon icon-class="add" />&nbsp;添加领取记录
          </el-button>
        </el-row>
      </div>
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="user_name" label="申请领取人" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="apply_time" label="申请时间" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="receive_time" label="领书时间" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="领取书名" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="book_no" label="领取图书编号" min-width="7%"></el-table-column>
          <el-table-column prop="borrow_num" label="领取数量" min-width="7%"></el-table-column>
          <el-table-column prop="status" label="状态" min-width="7%">
            <template slot-scope="scope">{{ scope.row.status | filterStatus }}</template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" min-width="10%">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">
                <a class="m-btn mr-10" @click="borrowPass(scope.row)">通过</a>
                <a class="m-btn mr-10" @click="borrowRefuse(scope.row)">拒绝</a>
              </span>

              <span v-else-if="scope.row.status == 2">
                <a class="m-btn mr-10" @click="receive(scope.row.id)">领取</a>
              </span>

              <span v-else>
                <a class="m-btn mr-10">-</a>
              </span>
              <!-- <a class="m-btn mr-10" @click="handleInterView( scope.row.id)">编辑</a> -->
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <el-dialog title="新增领取记录" :visible.sync="dialogVisible" :before-close="handleClose" width="30%">
      <el-form class="g-form-grid" ref="addForm" :model="addForm" label-width="90px" :rules="rules">
        <el-form-item label="领取人 :" prop="userId">
          <el-select v-model="addForm.userId" filterable remote reserve-keyword placeholder="请选择领取人" :remote-method="remoteMethod" :loading="loading">
            <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="申请时间 :" style="width: 100%" prop="applyTime">
          <el-date-picker v-model="addForm.applyTime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择"></el-date-picker>
        </el-form-item>

        <el-form-item label="图书名称 :"  prop="bookId">
          <el-select v-model="addForm.bookId"  filterable remote reserve-keyword :remote-method="remoteBookMethod" :loading="bookLoading" placeholder="请选择">
            <el-option v-for="item in receiveBookList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="领书时间 :" style="width: 100%" prop="receiveTime">
          <el-date-picker v-model="addForm.receiveTime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择"></el-date-picker>
        </el-form-item>

        <!-- <el-form-item label="领取天数 :" prop="borrowDay">
          <el-input v-model="addForm.borrowDay" placeholder="请输入"></el-input>
        </el-form-item> -->

        <el-form-item label="领取数量 :" prop="borrowNum">
          <el-input type='number' v-model="addForm.borrowNum" placeholder="只允许输入数字"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      that: this,
      form: {
        name: '',
        bookNo: '',
        useName: '',
        type: 2
      },
      addForm: {
        applyTime: '',
        receiveTime: '',
        userId: '',
        type: 2,
        borrowDay: 1,
        borrowNum: '',
        // a8f45e9768c7f8aa4e31a302a5a8fcfc
        bookId: ''
      },
      bookLoading:false,
      loading: false,
      userList: [],
      receiveBookList: [],
      rules: {
        applyTime: [
          { required: true, message: '申请时间不能为空', trigger: 'blur' },
        ],

        receiveTime: [
          { required: true, message: '领书时间不能为空', trigger: 'blur' },
        ],

        bookId: [
          { required: true, message: '领书名称不能为空', trigger: 'blur' },
        ],
        userId: [
          { required: true, message: '领取人不能为空', trigger: 'blur' },
        ],

        borrowNum: [
          { required: true, message: '领取数量不能为空', trigger: 'blur' },
        ],
      },
      listLoading: true,
      tableData: [],
      listQuery: {
        currentPage: 1,
        size: 10
      },
      dialogVisible: false,
      total: 0,
    }
  },

  filters: {
    filterStatus(status) {
      switch (status) {
        case 0:
          return '已取消'
        case 1:
          return '待审批'
        case 2:
          return '待领书'
        case 3:
          return '已拒绝'
        case 4:
          return '已领书'
        default:
          return null

      }
    }
  },

  methods: {
    initData() {
      this.listLoading = true
      this.$api.book.getAdminPageList({
        ...this.form,
        ...this.listQuery
      }).then(res => {
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total
        }
        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
      })

    },

    // 领取图书列表
    getReceiveBookList(param) {
      this.receiveBookList = []
      this.$api.book.getBookPageList({
        ...param,
        currentPage: 1,
        type: 3,
        size: 99999
      }).then(res => {
        this.bookLoading = false
        if (res.success) {
          this.receiveBookList = res.result.records
        }
      }).catch(err => {
        this.bookLoading = false
      })
    },

    // 添加领取记录
    addBorrow() {
      this.dialogVisible = true
      this.getReceiveBookList()
    },

    // 领取人列表
    getUserInfo(param) {
      this.userList = []
      this.$api.book.getUserInfo(param).then(res => {
        this.loading = false
        if (res.success) {
          this.userList = res.result
        }
      })
    },

    // 下拉框查询领取人列表
    remoteMethod(query) {
      this.loading = true
      this.getUserInfo({ nameOrPhone: query })
    },

    remoteBookMethod(query){
      let param = {name:query}
      this.bookLoading = true
      this.getReceiveBookList(param)
    },

    // 重置
    restList(formName) {
      this.$refs[formName].resetFields()
      this.getUserInfo()
      this.listQuery.currentPage = 1
      this.initData()
    },

    //申请通过
    borrowPass(obj) {
      this.$common.confirm(
        {
          title: `是否通过${obj.user_name}领取申请？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.borrowPass({
            id: obj.id
          }).then(res => {
            if (res.success) {
              this.$message.success('申请通过')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    //申请拒绝
    borrowRefuse(obj) {
      this.$common.confirm(
        {
          title: `是否拒绝${obj.user_name}领取申请？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.borrowRefuse({
            id: obj.id
          }).then(res => {
            if (res.success) {
              this.$message.success('申请拒绝')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    //领书
    receive(id) {
      this.$common.confirm(
        {
          title: `是否已领书？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.receive({
            id: id
          }).then(res => {
            if (res.success) {
              this.$message.success('成功领书')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 归还
    returnBook(id) {
      this.$common.confirm(
        {
          title: `是否归还图书？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.returnBook({
            id: id
          }).then(res => {
            if (res.success) {
              this.$message.success('归还成功')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initData()
    },

    handleSubmit() {
      this.$refs['addForm'].validate(vaild => {
        if (vaild) {
          this.$api.book.addAdminRecord({
            ...this.addForm,
          }).then(res => {
            if (res.success) {
              this.$message.success('新增成功')
              this.handleClose()
              this.initData()
            }else{
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    handleClose() {
      this.$refs['addForm'].resetFields()
      this.dialogVisible = false
    },
    getTableList() {
      this.listQuery.currentPage = 1
      this.initData()
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    }
  },

  mounted() {
    this.getUserInfo()
    this.initData()
    window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.com-search-box {
  /deep/ .el-col {
    margin-bottom: 30px;
  }
}

/deep/ .el-date-editor {
  width: 100%;
}

.el-form-state1{
  /deep/ .el-form-item__label{
    width: 70px !important;
  }

  /deep/ .el-form-item__content{
    margin-left: 70px !important;
  }
}

</style>